module.exports = __webpack_public_path__ + "media/images/flags/SG-fdb10c4b842976a9c6d301d44206af20.svg";